import React from 'react';
import classnames from 'classnames';
import { withLocalize } from 'react-localize-redux';
import BbCollapse from '../../../common/BbCollapse';
import AngleDownIcon from '../../../../img/icons/BBiconsRozbalit';

class RepiDataCorrectionSection extends React.Component {
    state = {
        isOpen: this.props.isOpen || false,
    };

    render() {
        return (
            <div className={classnames("old-style-report-section", { "is-expanded": this.state.isOpen })} ref={el => this.holder = el}>
                <div className="old-style-header-body" onClick={() => this.headerClick()}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                        <div className="repi-datacorrection-header-left" style={{ display: "flex", flexDirection: "row" }}>
                            <div className="icon-wrap">
                                <AngleDownIcon
                                    style={{ transform: `scaleY(${this.state.isOpen ? -1 : 1})`, transition: "all .5s ease", width: "1.4em", height: "1.4em" }}
                                    className="svg-standard-fill"
                                />
                            </div>
                            <div style={{fontWeight: this.props.isBold ? "bold":"normal"}}>{this.props.name}</div>
                        </div>
                        <div className="repi-datacorrection-header-right">
                            {this.props.rightContent}
                        </div>
                    </div>
                </div>
                <BbCollapse className="old-style-report-section-body" tag="div" isOpen={this.state.isOpen}>
                    {this.props.hasSpace && <div style={{ paddingTop: ".25em"}}></div>}
                    {this.props.children}
                </BbCollapse>
            </div>
        )
    }

    headerClick = () => {
        this.setState({ isExpandedTouched: true, isOpen: !this.state.isOpen })
    }
}

export default withLocalize(RepiDataCorrectionSection)